/**
 * @copyright Microsoft Corporation. All rights reserved.
 *
 * @file Analytics Stats component
 */

import * as React from 'react';
import { autobind } from 'office-ui-fabric-react/lib/Utilities';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { IKeyPointsData, IKeyPoints } from '../../../models/ItemAnalytics';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { List } from 'office-ui-fabric-react/lib/List';
import strings from '../FileHoverCard.resx';
import * as StringHelper from '@ms/utilities-strings/lib/index';
import * as AnalyticsKeyPointsStyle from './AnalyticsKeyPoints.scss';

const NUMBER_OF_KEYPOINTS_TO_SHOW = 3;

export interface IAnalyticsKeyPointsProps {
  keyPointsData?: IKeyPointsData;
  onKeyPointsClick?: () => void;
}

export class AnalyticsKeyPoints extends React.Component<IAnalyticsKeyPointsProps, {}> {
  constructor(props: IAnalyticsKeyPointsProps) {
    super(props);
  }

  public render(): JSX.Element {
    const tooltipMessage = strings.insideLookTooltipMessage;
    const { keyPointsData } = this.props;

    return (
      <div className={ `${AnalyticsKeyPointsStyle.msFileHoverCardInsideLook}` }>
        <div className={ `${AnalyticsKeyPointsStyle.msFileHoverCardInsideLookTitle}` }>
          { strings.insideLook }
          {
            <TooltipHost content={ tooltipMessage }>
              <Icon
                iconName={ 'Info' }
                aria-describedby={ tooltipMessage }
              />
            </TooltipHost>
          }
        </div>
        { keyPointsData && keyPointsData.readTime && keyPointsData.readTime.minutes &&
          <div className={ `${AnalyticsKeyPointsStyle.msFileHoverCardReadTime}` }>
            {
              <Icon
                className={ `${AnalyticsKeyPointsStyle.msFileHoverCardReadTimeIcon}` }
                iconName={ 'Clock' }
                aria-describedby={ tooltipMessage }
              />
            }
            {
              <div className={ `${AnalyticsKeyPointsStyle.msFileHoverCardReadTimeDescription}` }>
                {
                  StringHelper.format(strings.timeToRead, keyPointsData.readTime.minutes)
                }
              </div>
            }
          </div>
        }
        { keyPointsData && keyPointsData.keyPoints && (keyPointsData.keyPoints.length > 0) &&
          < div className={ `${AnalyticsKeyPointsStyle.msFileHoverCardKeyPoints}` }>
            <div>
              { strings.keyPointsTitle }
            </div>
            <div className={ `${AnalyticsKeyPointsStyle.msFileHoverCardKeyPointsContent}` }>
              {
                <Link
                  className={ `${AnalyticsKeyPointsStyle.msFileHoverCardKeyPointsAction}` }
                  onClick={ this._onClick }
                >{
                    <List
                      renderCount={ NUMBER_OF_KEYPOINTS_TO_SHOW }
                      items={ keyPointsData && keyPointsData.keyPoints }
                      onRenderCell={ this._onRenderCell }
                    />
                  }
                </Link>
              }
            </div>
          </div>
        }
      </div>
    );
  }

  @autobind
  private _onClick(ev: React.MouseEvent<HTMLElement>): void {
    this.props.onKeyPointsClick && this.props.onKeyPointsClick();
  }

  @autobind
  private _onRenderCell(item: IKeyPoints, index?: number): JSX.Element {
    return (
      <div className={ `${AnalyticsKeyPointsStyle.msFileHoverCardKeyPointsCell}` }>
        <div className={ `${AnalyticsKeyPointsStyle.msFileHoverCardKeyPointsBullet}` } />
        <div className={ `${AnalyticsKeyPointsStyle.msFileHoverCardKeyPointsText}` }>{ item.text }</div>
      </div>
    );
  }
}